"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutSuccess = void 0;
const Leaf = __importStar(require("leaf-ts"));
const checkoutSuccess_html_R_1 = require("./checkoutSuccess/checkoutSuccess.html.R");
const checkoutSuccess_html_R_2 = require("./checkoutSuccess/checkoutSuccess.theme/business/checkoutSuccess.html.R");
const checkoutSuccess_html_R_3 = require("./checkoutSuccess/checkoutSuccess.theme/genesis/checkoutSuccess.html.R");
const web_1 = require("@branch-ts/web");
const debug_consensus_1 = require("@branch-ts/debug-consensus");
const log_consensus_1 = require("@branch-ts/log-consensus");
const business_consensus_1 = require("@branch-ts/business-consensus");
const verset_consensus_1 = require("@project/verset_consensus");
const versetFacilityMechanism_1 = require("../versetFacilityMechanism");
const versetUserProfileMechanism_1 = require("../versetUserProfileMechanism");
class CheckoutSuccess extends checkoutSuccess_html_R_1.R.CheckoutSuccess {
    constructor() {
        super();
        this.debug = debug_consensus_1.Debug.instance(this).tag("CheckoutSuccess").enable();
        this.confirmed = false;
        this.present = web_1.PresentMechanism.about(this).lifeCycle(async (about) => {
            await about.declare("present");
            await this.refresh();
            await about.declare("hang");
        });
        this.fault = (0, web_1.FatUIErrorBestPractice)();
    }
    async refresh() {
        const server = versetFacilityMechanism_1.VersetFacilityMechanism.ensureServer();
        const parsed = business_consensus_1.CheckoutReturnUrlContract.parseURL({
            url: window.location.href,
            requireRemoteCheckoutId: true,
        });
        if (!parsed.ok) {
            this.showInvalidReturn();
            return;
        }
        this.VM.title = "Confirming Checkout";
        this.VM.message = "We are confirming the current status with Verset.";
        for (let attempt = 0; attempt <= 10; attempt += 1) {
            const [result, reason, ...errors] = await server.rpcs.VersetUserBillingService.getMyCheckoutReturn({
                subjectURI: parsed.value.subjectURI,
            });
            this.fault.caution.worry({
                message: "Failed to get Checkout return status",
                reason,
                errors,
            });
            if (!result) {
                return;
            }
            switch (result.checkoutReturn.type) {
                case verset_consensus_1.VersetProtocol.CheckoutReturn.Type.Subscription: {
                    this.VM.subscriptionName = result.checkoutReturn.plan || "Subscription";
                    this.VM.nextBillingDate = result.checkoutReturn.nextBillingAt
                        ? new Date(result.checkoutReturn.nextBillingAt).toLocaleDateString()
                        : "Confirming payment";
                    if (result.checkoutReturn.state === "active") {
                        this.confirmed = true;
                        this.VM.title = "Subscription active";
                        this.VM.message = "Your subscription is ready to use.";
                        versetUserProfileMechanism_1.VersetUserProfileMechanism.refreshFromCheckout();
                        log_consensus_1.Logger.log("Verset conversion", { step: "paymentConfirmed", kind: "subscription" });
                        return;
                    }
                    if (attempt === 10) {
                        this.VM.title = "Still confirming subscription";
                        this.VM.message = "Stripe may still be confirming this Checkout. Your subscription will update automatically after confirmation.";
                        return;
                    }
                    break;
                }
                case verset_consensus_1.VersetProtocol.CheckoutReturn.Type.PreCharge: {
                    this.VM.subscriptionName = "Additional usage";
                    this.VM.nextBillingDate = this.describePreChargeStatus(result.checkoutReturn);
                    if (result.checkoutReturn.state === "settled") {
                        this.confirmed = true;
                        this.VM.title = "Additional usage ready";
                        this.VM.message = "Your payment is complete and the additional Verset usage is ready to use.";
                        versetUserProfileMechanism_1.VersetUserProfileMechanism.refreshFromCheckout();
                        log_consensus_1.Logger.log("Verset conversion", { step: "paymentConfirmed", kind: "additionalUsage" });
                        return;
                    }
                    if (result.checkoutReturn.state === "needsAttention" || attempt === 10) {
                        this.VM.title = result.checkoutReturn.state === "needsAttention"
                            ? "Additional usage needs attention"
                            : "Still confirming additional usage";
                        this.VM.message = result.checkoutReturn.state === "needsAttention"
                            ? "We could not complete this additional-usage payment automatically. Review Billing History or contact support."
                            : "Stripe may still be confirming this payment. Review Billing History shortly; a verified payment will be applied automatically.";
                        return;
                    }
                    break;
                }
            }
            await new Promise((resolve) => window.setTimeout(resolve, 500));
        }
    }
    showInvalidReturn() {
        this.VM.title = "Checkout return unavailable";
        this.VM.message = "We could not identify this Checkout return. No payment or account change is confirmed here.";
        this.VM.subscriptionName = "Checkout";
        this.VM.nextBillingDate = "Return to Billing to review your current status";
    }
    describePreChargeStatus(status) {
        const points = `${status.expectedPointAmount.toLocaleString()} VP`;
        switch (status.state) {
            case "checkout": return "Waiting for Stripe to confirm your payment";
            case "payment": return "Payment received; preparing your additional usage";
            case "settling": return "Payment received; applying your additional usage";
            case "settled": return `${points} is ready to use`;
            case "needsAttention": return "This payment needs attention; please contact support";
        }
    }
    onClickViewSubscriptionBtn(e) {
        e?.stopPropagation();
        e?.preventDefault();
        window.location.href = "/dashboard/billing";
    }
    onClickBackToHomeBtn(e) {
        e?.stopPropagation();
        e?.preventDefault();
        if (this.confirmed)
            log_consensus_1.Logger.log("Verset conversion", { step: "returnedToWork" });
        versetUserProfileMechanism_1.VersetUserProfileMechanism.returnToWork();
    }
}
exports.CheckoutSuccess = CheckoutSuccess;
Leaf.WidgetThemeCenter.about(checkoutSuccess_html_R_1.R.CheckoutSuccess).add("business", checkoutSuccess_html_R_2.R.CheckoutSuccess.generator);
Leaf.WidgetThemeCenter.about(checkoutSuccess_html_R_1.R.CheckoutSuccess).add("genesis", checkoutSuccess_html_R_3.R.CheckoutSuccess.generator);
